module.exports = __webpack_public_path__ + "img/visibility-off.ad7a2532.svg";